import { render, staticRenderFns } from "./ExtraNotes.vue?vue&type=template&id=f0652058&"
import script from "./ExtraNotes.vue?vue&type=script&lang=js&"
export * from "./ExtraNotes.vue?vue&type=script&lang=js&"
import style0 from "./ExtraNotes.vue?vue&type=style&index=0&id=f0652058&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0652058')) {
      api.createRecord('f0652058', component.options)
    } else {
      api.reload('f0652058', component.options)
    }
    module.hot.accept("./ExtraNotes.vue?vue&type=template&id=f0652058&", function () {
      api.rerender('f0652058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/ExtraNotes.vue"
export default component.exports